import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 md:px-12 pt-32 pb-[20px]">
        <h1 className="font-heading text-[30px] sm:text-[45px] font-semibold text-[#08122a] tracking-tight leading-tight mb-4">Privacy Policy</h1>
        <p className="font-body text-sm text-[#475569] mb-12">Last updated: February 1, 2026</p>

        <div className="space-y-10 font-body text-[#475569] text-base leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">1. Introduction</h2>
            <p>Nebula Flow ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or engage with our services.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">2. Information We Collect</h2>
            <p className="mb-3">We may collect information about you in a variety of ways, including:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong className="text-[#08122a]">Personal Data:</strong> Name, email address, phone number, company affiliation, and other contact details you voluntarily provide when reaching out to us.</li>
              <li><strong className="text-[#08122a]">Usage Data:</strong> Information about how you interact with our website, including IP address, browser type, pages visited, and time spent on pages.</li>
              <li><strong className="text-[#08122a]">Cookies and Tracking:</strong> We use cookies and similar technologies to enhance your browsing experience. See our Advertising and Cookies page for more details.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">3. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>To respond to inquiries and communicate with potential portfolio companies and partners.</li>
              <li>To improve our website, services, and user experience.</li>
              <li>To comply with legal obligations and protect our rights.</li>
              <li>To send periodic updates about our fund activities, if you have opted in.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">4. Information Sharing</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. We may share information with trusted service providers who assist us in operating our website and conducting our business, subject to confidentiality agreements.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">5. Data Security</h2>
            <p>We implement industry-standard security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">6. Your Rights</h2>
            <p>Depending on your jurisdiction, you may have the right to access, correct, delete, or restrict the processing of your personal data. To exercise these rights, please contact us at info@nebula-f.com.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">7. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">8. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us at info@nebula-f.com or at our offices at 2 Eastbourne Terrace, Paddington, London W2 6LG, UK.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
